import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { ProfilePage } from "./profile.page";

const routes: Routes = [
  {
    path: "",
    component: ProfilePage,
  },
  {
    path: "profile-detail",
    loadChildren: () =>
      import("../profile-detail/profile-detail.module").then(
        (m) => m.ProfileDetailPageModule
      ),
  },
  {
    path: 'config',
    loadChildren: () => import('../profile-config/profile-config.module').then( m => m.ProfileConfigPageModule)
  },
  {
    path: "orders",
    loadChildren: () =>
      import("../orders/orders-routing.module").then(
        (m) => m.OrdersPageRoutingModule
      ),
  },
  {
    path: "orders/:id",
    loadChildren: () =>
      import("../order-detail/order-detail.module").then(
        (m) => m.OrderDetailPageModule
      ),
  },
  {
    path: "history-points",
    loadChildren: () =>
      import("../history-points/history-points.module").then(
        (m) => m.HistoryPointsPageModule
      ), 
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfilePageRoutingModule {}
